// extracted by mini-css-extract-plugin
module.exports = {"container":"universeBeyondCheckbox_container__vi61C"};